<template>
  <div class="page">
    <div class="group_1">
      <div v-if="this.list.length > 0">
        <div class="box_1" v-for="item in list" :key="item.classId">
          <!-- <div class="title">
            <div class="text_1">证书编号：{{ item.certNo }}</div>
            <div class="text_2">{{ item.year }}年</div>
          </div> -->
          <!-- <van-divider /> -->
          <div class="title_1">
            <div class="text_3">班级名称</div>
            <div class="text_4">{{ item.className }}</div>
          </div>
          <div class="title_1">
            <div class="text_3">类型</div>
            <div class="text_4">{{ item.codeName }}</div>
          </div>
          <div class="title_1">
            <div class="text_3">年度</div>
            <div class="text_4">{{ item.year }}</div>
          </div>
          <div class="title_1">
            <div class="text_3">完成学时</div>
            <div class="text_4">{{ item.finishCredit }}</div>
          </div>
          <!-- <div class="title_1">
            <div class="text_3">打印状态</div>
            <div class="text_4">{{ item.printFlag == '01' ? '未打印' : '已打印' }}</div>
          </div> -->
          <van-divider />
          <!-- <div class="btn" @click="gotoZs(item)">
            <div class="btn_1">查看证书</div>
          </div> -->
               <div class="btn" @click="goZs(item)">
            <div class="btn_1">证书申领</div>
          </div>
        </div>
      </div>
      <!-- <van-empty description="暂无证书" v-else /> -->
      <div @click="loadMore" v-if="hasMore" class="load-more">点击加载更多</div>
      <div v-else class="no-more">没有更多数据了~</div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import { toMyCertList } from '../../api/certificate';
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    // 这里存放数据
    return {
      list: [],
      pageSize:10,
      pageNum: 1,
      total: '',
      hasMore: true
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    loadMore() {
      this.pageNum++;
      this.getList();
    },
    getList() {
       const param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      toMyCertList(param).then(res => {
        if (this.pageNum == 1) {
          this.list = res.data.rows;
        } else {
          this.list = [...this.list, ...res.data.rows];
          console.log(this.list,'22ee');
          
        }
        this.total = res.data.total;
        this.hasMore = this.list.length < this.total;
      });
    },
    //去证书页
    gotoZs(item) {
      this.$router.push({
        path: '/zsCan',
        query: { classId: item.id }
      });
    },
    //去证书申领页
    goZs(item) {
      this.$router.push({
        path: '/applyFor',
        query: { classId: item.classId }
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getList();
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.page {
  background-color: #f6f8fa;
  height: 100vh;
  overflow-y: scroll;
}
.load-more,
.no-more {
  text-align: center;
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.no-more {
  color: #666;
}
.group_1 {
  padding: 10px 15px;
  .box_1 {
    margin-bottom: 10px;
    // width: 345px;
    // height: 280px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    padding: 16px 15px;
    .title {
      display: flex;
      justify-content: space-between;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 13px;
      .text_1 {
        color: #667280;
      }
      .text_2 {
        width: 58px;
        height: 26px;
        line-height: 26px;
        text-align: center;
        background: rgba(42, 112, 242, 0.1);
        border-radius: 4px 4px 4px 4px;
        color: #2a70f2;
      }
    }
    .title_1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      margin-bottom: 16px;
      justify-content: space-between;
      color: #333333;
      display: flex;
      .text_4 {
        width: 200px;
        text-align: right;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: #667280;
      }
    }
  }
}
.btn {
  display: flex;
  justify-content: flex-end;
  .btn_1 {
    width: 108px;
    height: 36px;
    background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
    border-radius: 16px 16px 16px 16px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
  }
}
</style>
